import { EuiPageTemplate, EuiButton } from "@inscopix/ideas-eui";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";

interface CreatePersonalSpaceSuccessProps {
  personalSpace: {
    key: string;
  };
}

export const CreatePersonalSpaceSuccess = ({
  personalSpace,
}: CreatePersonalSpaceSuccessProps) => {
  const routeMap = useRouteMapContext((s) => s.routeMap);
  return (
    <EuiPageTemplate.EmptyPrompt
      title={<span>Your space is ready!</span>}
      iconType={"spacesApp"}
      color="success"
      footer={
        <EuiButton
          fill
          onClick={() =>
            routeMap.ORGANIZATION.dynamicPath({
              tenantKey: personalSpace.key,
            }).navigateTo()
          }
        >
          Go to your space
        </EuiButton>
      }
    >
      You&apos;re all set to go - use the button below to get started in your
      new personal space!
    </EuiPageTemplate.EmptyPrompt>
  );
};
